import { FC, useMemo } from 'react';

import type { IUndergroundAdornmentProps } from '../../../../../packages/Tags/shared/types/tag';

import { getUndergroundIcon } from './utils';

import styles from './UndergroundIcon.css';

export const UndergroundIcon: FC<IUndergroundAdornmentProps> = ({ regionId, color }) => {
  const icon = useMemo(() => getUndergroundIcon(regionId), [regionId]);

  return (
    <div style={{ color: `#${color}` }} className={styles['icon']}>
      {icon}
    </div>
  );
};
